import React from 'react';
import { Modal, Button } from '@/components';
import './agrt-modal.less';
import {
  AgreeEnum,
  setArgtStorage,
  getArgtStorage,
  removeArgtStorage,
} from './argt';
import ReactDOM from 'react-dom';
const tempModalClassName = 'home-agreement-modal-temp-modal';
/**
 * 透明遮罩层
 * 此处加一个透明遮罩目的：当协议弹窗弹出后，用户没有点已读，点的是稍后
 * 之后用户任何的点击操作我们都再次弹协议弹窗，所以做了个遮盖整个页面的透明弹层
 * 这样点击透明弹层我们就弹协议
 */
class TempModal extends React.Component {
  el = document.createElement('div');
  show = () => {
    document.body.appendChild(this.el);
  };
  hide = () => {
    const e = document.getElementsByClassName(tempModalClassName)[0];
    if (e) document.body.removeChild(this.el);
  };
  componentWillUnmount() {
    this.hide();
  }
  render() {
    return ReactDOM.createPortal(
      <div
        className={tempModalClassName}
        onClick={() => {
          AgrtModalRender.show();
        }}
      ></div>,
      this.el,
    );
  }
}
const TempModalRender = ReactDOM.render(
  React.createElement(TempModal, {}),
  document.createElement('div'),
);

class AgrtModal extends React.Component {
  state = {
    visible: false,
  };
  show = () => {
    if (getArgtStorage() === AgreeEnum.YES) return;
    this.setState({
      visible: true,
    });
  };
  hide = () => {
    this.setState({
      visible: false,
    });
  };
  render() {
    const { visible } = this.state;
    return (
      <Modal visible={visible}>
        <div className="home-agreement-modal flex flex-column">
          <div className="agrt-title tc">《小部件开放平台协议》</div>
          <div className="agrt-content flex1">
            <section className="artile-box">
              <div className="article-title">一、说明</div>
              <p className="article-content">
                1、《小部件开放平台协议》（以下简称“本协议”）适用于所有在小部件开放平台上发布小部件的发布者。
                本协议连同小米开放平台公布的《小米开发者站应用发布协议》、应用商店文档、应用审核规范、MIUI小部件规范及其他规则、制度和政策，共同构成了发布者与小米公司之间的协议，一经发布者同意接受后即形成发布者与小米公司间有法律约束力之文件。发布者在小部件开放平台以任何形式提供、上传小部件及其相关文件将受本条款之规范。如发布者不同意本协议任意内容的，发布者将无法在小部件开放平台发布任何小部件作品。
              </p>
              <p className="article-content">
                2、一旦发布者接受本条款，发布者保证发布者已达法定年龄且具有完全之行为能力，如果发布者代表一个公司，组织或其他法律实体，发布者保证发布者的公司或组织是根据发布者居住地之法律所成立且持续有效的法律实体，发布者声明并保证发布者的公司或组织已合法授权发布者代表发布者的公司或组织加入小部件开放平台并发布小部件。
                如果发布者的作品包括任何开源软件，发布者保证遵守所有适用的开源软件授权条款。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">二、定义</div>
              <p className="article-content">1、发布者</p>
              <p className="article-content">
                指有效申请并经小米公司审核同意后，在小部件开放平台上发布小部件作品的发布者，包括法人、其他组织或自然人。
              </p>
              <p className="article-content">2、小部件开放平台</p>
              <p className="article-content">
                是一个开放性的应用小部件的发布平台，由小米科技有限责任公司（下称“小米公司”）所有和经营。
              </p>
              <p className="article-content">3、作品</p>
              <p className="article-content">
                发布者在小部件开放平台发布或更新的其拥有合法权利的任何信息或材料，包括但不限于服务、应用程序、数据、文件、软件、音乐、声音、图片（包括预览图）、文字（包括小部件简介）、图像、图形、影音讯息、答案、问题、意见、建议、暗示、策略、观念、设计、想法、计划等。
              </p>
              <p className="article-content">4、用户</p>
              <p className="article-content">
                指所有直接或间接使用发布者发布或更新至小部件开放平台上的作品的用户。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">三、费用计算与收益分配</div>
              <p className="article-content">
                1、小米公司免费为发布者提供本协议下约定的发布平台与服务，但并不排除今后就其提供的上述服务与其他新增服务收取费用和分享发布者收益的可能。费用的数额、比例以及收益分享模式会在本协议的更新版本中另行规定。
              </p>
              <p className="article-content">
                2、在前述本协议的更新版本公示后，发布者如继续使用小部件开放平台及其服务，则视为对本协议的更新版本内容的同意；发布者在不同意本协议的更新版本内容的情况下，有权停止使用小部件开放平台及其服务，但发布者在其停止使用小部件开放平台之前的行为，仍受本协议限制。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">四、知识产权及所有权</div>
              <p className="article-content">
                1、发布者在小部件开放平台上发布的作品的所有权和知识产权归属于发布者或其合法权利人。作品如涉及到第三方的合法权利，发布者应在作品发布之前获得相关权利人的授权。小部件开放平台在审查批准上传作品时，会默认发布者拥有其发布作品的合法权利。
              </p>
              <p className="article-content">
                2、发布者保证其在小部件开放平台发布的作品不侵犯第三人的合法权益。如发布者所发布的作品存在侵权情形，小部件开放平台在收到针对发布者作品有效的侵权投诉，或者接收到行政执法部门或司法机关的通知时，有权不经通知立即对有关产品、信息等进行屏蔽、冻结或者移除处理。小米不承担因此对发布者造成的任何损失。第三方权利人依法有效投诉的同时要求小米披露发布者身份信息以便通过法定渠道（法院等）进行维权的，小米有权向其提供。
              </p>
              <p className="article-content">
                3、小部件开放平台中可能包含的文本、图片、音频、视频、商标等信息和资料的相关权利均归小米公司所有或由小米公司经合法授权取得，未经小米公司及其他相关权利人同意，上述信息或资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。
              </p>
              <p className="article-content">
                4、小部件开放平台为提供平台服务而使用的任何应用程序（包括但不限于应用程序中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于小米公司或该软件的著作权人，未经权利人许可，发布者不得擅自使用。
              </p>
              <p className="article-content">
                5、发布者所上传之作品所有权归发布者所有，发布者同意并授权小米公司非排他、全球性、不可撤销性和免授权费、可转让、可分许可之授权以利小米公司进行使用、复制、修改、翻译、转载、出版、公开展演、与公开传输。并授权小部件开放平台有权在第三方渠道上对发布者作品进行分发以及宣传。另发布者授权小米公司及其顾问，供货商和承包商基于市场营销之目的使用发布者的作品或品牌；但本条款并不授权发布者可使用小米公司的品牌商标。
              </p>
              <p className="article-content">
                6、发布者同意并授权通过小部件开放平台取得发布者作品的用户非排他、全球性的长期使用发布者的作品；如果用户与发布者达成其他协议时，相关之规定应依发布者与用户所达成之协议为准，如有任何纠纷发生应依发布者与用户所达成之其他协议为准，概与小米公司无关。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">五、发布者的权利与义务</div>
              <p className="article-content">
                1、发布者有权在小部件开放平台上发布其作品，并使用小部件开放平台提供的各项功能与服务。未经小米公司书面同意，发布者不得就其发布的作品向用户收取任何费用。
              </p>
              <p className="article-content">
                2、发布者应当妥善保管其平台账号和密码，通过发布者账号完成的行为均视为发布者本人完成。
                发布者有权随时更改密码，若发布者发现或合理怀疑其账号存在安全风险或被非法使用，发布者应当立即通知小部件开放平台。未经小米公司书面同意，发布者账号不得许可或转让给第三方使用，不得作为财产分割或继承，本协议终止后，小米公司有权收回或注销发布者账号。
              </p>
              <p className="article-content">
                3、发布者保证：其提供给小米公司的所有信息，包括但不限于其姓名（名称）、地址、电子邮箱等相关资料真实、合法、准确、完整。如上述信息发生变化，发布者应在三个工作日内变更信息。如小米公司发现不真实、不合法或不准确的信息，随时有权中止或终止向其提供本协议下服务并且不承担任何责任。
              </p>
              <p className="article-content">
                4、发布者作品应当符合小部件开放平台的审核规范和相关规则。发布者同意：其提供的作品先经小米公司审核并同意后，方可在小部件开放平台发布；作品发布后，小米公司有权持续该等审核。且上述审核过程中，小米公司有完全的权利判断是否同意发布或终止发布该作品，包括在不通知发布者的情况下，不同意发布作品，或对已经发布的作品进行删除、屏蔽等处理。
              </p>
              <p className="article-content">
                5、发布者应保证其发布的作品不含有任何违反法律法规、政策规定以及小部件开放平台的政策以及规则：
              </p>
              <p className="article-content">
                -
                发布者发布的作品中不得包含任何色情、反动、赌博、诽谤他人、虚假信息等非法信息，不存在盗取、破坏用户数据及系统的隐藏内容，也不侵犯任何人的合法权益，包括但不限于侵犯他人知识产权、名誉权、肖像权以及商业秘密等；
              </p>
              <p className="article-content">
                -
                发布者保证在发布有关医学医疗、生理卫生、婚姻家庭、人体艺术和与此相关的自然、社会科学信息内容时，对信息内容进行审核，做到合法、合规且内容健康、科学，来源合法、可靠；
              </p>
              <p className="article-content">
                -
                发布者保证对利用互联网电子公告服务系统，短信息服务系统传播淫秽、色情等不良信息的用户，应将其IP地址列入“黑名单”，对涉嫌犯罪的，应主动向公安机关举报；
              </p>
              <p className="article-content">
                -
                发布者保证不与非法网站建立任何性质的合作关系；不与其他网站或企业建立违背政府有关部门规定的联盟或协作关系；
              </p>
              <p className="article-content">
                -
                发布者保证不以任何形式登载和传播含有淫秽、色情、赌博等不良信息内容的广告；不为含有淫秽、色情、赌博等不良信息内容的网站或网页提供任何形式的宣传和链接。
              </p>
              <p className="article-content">发布者应保证符合以下要求：</p>
              <p className="article-content">
                -
                发布者应当在作品中尊重用户选择权、知情权。发布者应当确保用户在阅览和同意小部件应用的用户协议、服务政策后开启小部件功能；
              </p>
              <p className="article-content">
                - 发布者应当尊重用户隐私。发布的作品应当符合隐私相关的法律法规；
              </p>
              <p className="article-content">
                -
                发布者在未经用户同意的情况下，不得向用户发送商业广告或其他营销或促销信息；
              </p>
              <p className="article-content">
                -
                发布者应当按照法律法规以及小部件开放平台的要求提供产品信息，包括但不限于名称、功能描述等；
              </p>
              <p className="article-content">
                -
                发布者保证不会以任何方式干扰小部件开放平台的正常运营和提供的服务以及功能。不得避开或者试图避开任何内容保护机制；
              </p>
              <p className="article-content">
                -
                发布者需要遵守本协议内条款及小部件开放平台不定期发布的与相应服务相关的任何政策；
              </p>
              <p className="article-content">
                -
                发布者不得删除、隐匿、改变小部件开放平台的任何专利、版权、商标信息或其他所有权声明；
              </p>
              <p className="article-content">
                -
                发布者的作品中不得含有计算机病毒、木马或其他恶意程序等任何可能危害小部件开放平台或用户权益和终端信息安全等的内容；
              </p>
              <p className="article-content">
                - 其他小米公司认为不应该或者不恰当的行为或内容；
              </p>
              <p className="article-content">
                -
                发布者不得进行恶意干扰小米任何产品或其他互联网服务提供者的产品全部或部分功能的正常运行，或构成其他不正当竞争行为；
              </p>
              <p className="article-content">
                -
                发布者违反本协议承诺即视为违约，应当赔偿小米公司因此遭受的一切经济损失，如因发布者违反本协议承诺给小米公司造成不良影响，发布者应当授权小米公司对相关情况予以公开澄清。此外，发布者应当独立承担因发布者违约行为而产生的行政或刑事责任。
              </p>
              <p className="article-content">
                7、发布者同意并理解：小米公司仅向发布者提供发布其产品的相关平台技术支持服务，是一个中立的平台服务提供者，作品由发布者自主开发、独立运营，发布者保证在小部件开放平台发布的作品不存在明显的缺陷，并应对已发布的作品进行及时的更新维护，保证作品的稳定运行，并负责其作品的客户服务、作品运营和技术维护就其作品与用户之间的服务可能产生的任何纠纷、争议，由发布者和用户独立解决。
              </p>
              <p className="article-content">
                8、发布者保证不进行侵害用户隐私和数据安全的行为；非经用户明确同意，其不得通过任何方式、手段或途经获取用户的任何信息，或将该等信息用于非法用途或目的。发布者同意对用户之个人资料负绝对之保密义务及保管责任，未经用户之事前书面同意，绝不作超出本条款之目的范围之使用或以任何方式将其泄露、告知、交付于任何第三人。
              </p>
              <p className="article-content">
                9、发布者不得进行恶意干扰小米任何产品或其他互联网服务提供者的产品全部或部分功能的正常运行，或构成其他不正当竞争行为。
              </p>
              <p className="article-content">
                10、发布者应保证其发布的小部件不存在
                <a
                  className="mag-link"
                  href="https://dev.mi.com/distribute/risk-app-review.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  《风险应用审查标准》
                </a>
                中所包含的任意情形。基于保护用户权益和信息安全的原则，如发布者和其发布的小部件存在上述情况，小米公司有权按照
                <a
                  className="mag-link"
                  href="https://dev.mi.com/distribute/risk-app-review.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  《风险应用审查标准》
                </a>
                对发布者及其发布的作品采取相应措施。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">六、小米公司的权利与义务</div>
              <p className="article-content">
                1、小米公司负责小部件开放平台的平台建设与维护，并为小部件开放平台平台上发布的作品提供必要的市场宣传和推广。
              </p>
              <p className="article-content">
                2、小米公司有权就发布者在小部件开放平台发布的作品进行复制、传播和推广，授权用户下载和使用，但应保留作品原有的著作权标识或信息；小米公司有权根据其需要对已发布作品的位置进行调整或删除作品；小米公司有权通过对发布者在小米应用商店发布的应用进行解析直接获取小部件相关信息，包括但不限于小部件名称、小部件尺寸等。经过发布者同意，小米公司可以对作品进行修改和编辑。
              </p>
              <p className="article-content">
                3、小米公司不因下述任一情况而可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其它无形损失：
              </p>
              <p className="article-content">
                -
                因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致小部件开放平台系统障碍不能正常运作；
              </p>
              <p className="article-content">
                -
                由于黑客攻击、电信部门技术调整或故障、系统维护等原因而造成的平台服务中断或者延迟；
              </p>
              <p className="article-content">
                -
                由于政府命令、法律法规的变更、司法机关及行政机关的命令、裁定等原因而导致的小部件开放平台服务中断、终止或延迟。
              </p>
              <p className="article-content">
                4、如发生下列任一情形，小米公司有权以其认为合理的程度和普通人的知识水平做出判断和处理，包括但不限于删除作品等信息，终止或暂停向发布者、用户提供全部或部分服务：
              </p>
              <p className="article-content">
                -
                违反了小米开放平台审核相关规范、管理政策及小部件开放平台其他政策以及规定；
              </p>
              <p className="article-content">
                -
                包含任何色情、反动、赌博、诽谤他人、虚假信息等非法信息以及侵害第三人知识产权、名誉权、肖像权或其他权利等违反相关法律法规的规定；
              </p>
              <p className="article-content">- 存在不正当竞争等行为；</p>
              <p className="article-content">
                -
                内容包含病毒或被认定为恶意软件、间谍软件。如果发布者作品的内容是因为有瑕疵的或为恶意软件而不能自愿性移除时，小米公司有权向发布者收取因移除有瑕疵的或为恶意软件的所有费用；
              </p>
              <p className="article-content">- 存在其他不良影响或者风险。</p>
              <p className="article-content">
                5、小米公司保留随时变更或终止小部件开放平台平台服务的权利，并无需对行使该权利向发布者承担责任。小米公司可通过网页公告、电子邮件、电话或信件传送等方式向发布者和用户发出通知，该等通知在发送时即视为已送达收件人。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">七、违约责任与赔偿</div>
              <p className="article-content">
                1、发布者违反本协议承诺即视为违约，应当赔偿小米公司因此遭受的一切经济损失，如因发布者违反本协议承诺给小米公司造成不良影响，发布者应当授权小米公司对相关情况予以公开澄清。此外，发布者应当独立承担因发布者违约行为而产生的行政或刑事责任。
              </p>
              <p className="article-content">
                2、在适用法律允许的最大范围内，发布者访问和使用小部件开放平台服务的风险由发布者自行承担。小米公司对发布者的最大及全部责任以及发布者在本协议下使用或无法使用本服务而造成的任何及所有赔偿、索赔、责任、损失或损害的唯一救济措施是基于发布者遭受的实际经济损失，且无论是基于合同、侵权（包括疏忽）或其它任何理论，对发布者的赔偿不超过小米公司依照本协议所获得的收益。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">八、隐私条款</div>
              <p className="article-content">
                1、小米公司非常重视您的个人信息和隐私保护，我们将会按照法律要求，收使用您的个人信息并提供相应的安全保护措施。
              </p>
              <p className="article-content">
                2、为了向您提供小部件开放平台的相关服务，我们将收集您的以下个人信息：
              </p>
              <p className="article-content">
                -
                如果您申请企业开发者，我们会收集您的注册邮箱、联系人姓名、电子邮箱、QQ号，以便为您进行企业账号注册，同时如果您选择通过企业对公银行账户信息完成认证，我们也会收集企业管理员的姓名、身份证号码、手机号、身份证照片、法定代表人姓名，以便为您企业进行资质认证。
              </p>
              <p className="article-content">
                -
                您使用小部件开放平台产生的相关数据，包括浏览记录、搜索记录、信息提交记录、问题日志和IP，用于确保您的操作安全。
              </p>
              <p className="article-content">
                3、如果您想要了解更多信息，请参考
                <a
                  href="https://privacy.mi.com/all/zh_CN"
                  target="_blank"
                  className="mag-link"
                  rel="noreferrer"
                >
                  《小米隐私政策》
                </a>
                。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">九、免责事由</div>
              <p className="article-content">
                1、小米公司审核发布者及其作品的行为并不意味着小米公司对其审核结果承担任何法律责任，包括对发布者的资质、其作品承担任何保证或法律责任。开发者须对其上传的产品、内容负全部责任。
              </p>
              <p className="article-content">
                2、发布者理解并同意，小米公司及其附属公司、子公司、管理人员、董事、员工、代理商、合作伙伴和授权方，在下述情况里，对发布者的任何直接、间接、附带、特别、衍生性或惩罚性的损害，不承担任何责任，包括但不限于利润损失、商誉损失、数据丢失的损失以及其他无形损失：
              </p>
              <p className="article-content">- 使用或无法使用本服务；</p>
              <p className="article-content">
                -
                对本服务的变更、任何临时或永久性的对全部或部分服务的停止，包含但不限于小部件开放平台业务调整原因或自然因素之不可抗力、政府命令等导致；
              </p>
              <p className="article-content">
                - 未经授权的访问或更改您的传输或数据；
              </p>
              <p className="article-content">
                - 删除、毁坏或未能存储和/或发送或接收您通过本服务的传输或数据；
              </p>
              <p className="article-content">
                - 服务中任何第三方的声明或行为；
              </p>
              <p className="article-content">- 任何其他与本服务有关的事宜。</p>
            </section>
            <section className="artile-box">
              <div className="article-title">十、法律适用与司法管辖</div>
              <p className="article-content">
                本协议及因本协议产生的.一切法律关系及纠纷，均适用中华人民共和国法律。因发布者
                与小米公司就本协议而产生的任何纠纷，双方应本着友好的态度协商解决，协商无果的，任何一方都有权向小米公司所在地法院诉讼解决。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">十一、协议生效和有效期限</div>
              <p className="article-content">
                本协议自发布者在线签署同意之日起发生法律效力。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">十二、通知</div>
              <p className="article-content">
                1、小米公司可能会以网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、站内信等方式中的一种或多种，向发布者送达关于小部件开放平台的服务的各种通知、提示等信息，该等信息一经前述任何一种方式公布或发送，即视为送达。若开发者不接受的，请书面通知小米公司，否则视为您已经接受、同意。
              </p>
              <p className="article-content">
                2、若由于提供的电子邮箱、手机号码、通讯地址等信息错误，导致开发者未收到相关规则、通知、提示等信息的，与小米公司无关，一切后果及责任由开发者自行承担。
              </p>
              <p className="article-content">
                3、开发者同意小部件开放平台或合作伙伴可以向开发者的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息包括但不限于商业广告等。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">十三、协议更新</div>
              <p className="article-content">
                1、发布者了解并同意，小部件开放平台的业务不断变化，本协议无法涵盖当前或未来可能发生的所有情况，为此有必要通过修订、新增规则等形式不断完善本协议内容，以便更加明确发布者与小部件开放平台间的权利义务关系。小米公司有权对本协议进行变更，请定期查阅本协议。
              </p>
              <p className="article-content">
                2、本协议更新后，如果发布者继续使用小部件开放平台或其作品仍在小部件开放平台上线的，即视为发布者已接受修改后的协议，修改后的协议对发布者具有约束力。如果发布者不接受修改后的协议，应当停止使用小部件开放平台以及小部件开放平台提供的服务。
              </p>
            </section>
            <section className="artile-box">
              <div className="article-title">十四、一般条款</div>
              <p className="article-content">
                1、本协议的任何条款被法院或其他主管机关判定为无效，其他条款内容不受影响，仍对双方具有法律约束力。
              </p>
              <p className="article-content">
                2、本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
              </p>
            </section>
          </div>
          <div className="agrt-footer flex justify-between">
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setArgtStorage(AgreeEnum.NO);
                this.hide();
                TempModalRender.show();
              }}
            >
              稍后
            </Button>
            <Button
              type="primary"
              onClick={(e) => {
                e.stopPropagation();
                setArgtStorage(AgreeEnum.YES);
                this.hide();
                TempModalRender.hide();
              }}
            >
              已读
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
export const AgrtModalRender = ReactDOM.render(
  React.createElement(AgrtModal, {}),
  document.createElement('div'),
);
export default AgrtModalRender;
export { AgreeEnum, setArgtStorage, getArgtStorage, removeArgtStorage };
